export default "__VITE_ASSET__DNSpH6p4__ 409w";